module.exports = __webpack_public_path__ + "static/img/logo.eb7a165.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo.png
// module id = ZBJ4
// module chunks = 1